import React from 'react';

const formatNumber = (n) =>
  typeof n === 'number'
    ? n.toLocaleString(undefined, { maximumFractionDigits: 1 })
    : '-';

function Card({ title, value, subtitle, className }) {
  return (
    <div className={`col-6 col-md-3 mb-3 ${className || ''}`}>
      <div className="card shadow-sm h-100">
        <div className="card-body py-3">
          <div className="text-muted text-uppercase small">{title}</div>
          <div className="h5 mb-0">{value}</div>
          {subtitle && <div className="text-muted small mt-1">{subtitle}</div>}
        </div>
      </div>
    </div>
  );
}

export default function MetricsPanel({ metrics = {} }) {
  const {
    snapshotCount,
    diffCount,
    heartbeatSweeps,
    activeSessions,
    activePlayers,
    guestCount,
    latencyAvg,
    diffStats = {},
    memoryUsage,
    sweepMs,
  } = metrics;

  const mem =
    memoryUsage && memoryUsage.heapUsed
      ? `${(memoryUsage.heapUsed / 1024 / 1024).toFixed(1)} MB`
      : null;

  return (
    <div className="row g-2 g-md-3">
      <Card title="Snapshots" value={formatNumber(snapshotCount)} />
      <Card
        title="Diffs"
        value={formatNumber(diffCount)}
        subtitle={
          diffStats
            ? `+${formatNumber(diffStats.add)} / ~${formatNumber(
                diffStats.update,
              )} / -${formatNumber(diffStats.remove)}`
            : null
        }
      />
      <Card
        title="Sweeps"
        value={formatNumber(heartbeatSweeps)}
        subtitle={sweepMs ? `${formatNumber(sweepMs)} ms` : null}
      />
      <Card
        title="Latency"
        value={
          latencyAvg != null ? `${formatNumber(latencyAvg)} ms` : 'n/a'
        }
      />
      <Card title="Sessions" value={formatNumber(activeSessions)} />
      <Card title="Players" value={formatNumber(activePlayers)} />
      <Card title="Guests" value={formatNumber(guestCount)} />
      <Card title="Memory" value={mem || 'n/a'} />
    </div>
  );
}
